// extracted by extract-css-chunks-webpack-plugin
module.exports = {"center_box":"center_box-21F2m2Z0"};